// extracted by mini-css-extract-plugin
export var divider = "_ts-0";